import {createSlice, configureStore, createAsyncThunk} from '@reduxjs/toolkit';
import { api } from '../../api/apiClient';

export const fetchLatestSermon = createAsyncThunk(
  "sermon/fetchLatest",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/api/sermons/latest");

      console.log("RAW latest sermon response:", response.data);

      const sermon =
        response.data?.data ||
        response.data?.sermon ||
        response.data;

      if (sermon) return sermon;

      return rejectWithValue("Latest sermon not found");
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);



const latestSermonSlice = createSlice({
    name: 'latestSermon',
    initialState: {
        latestSermon: null,
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchLatestSermon.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchLatestSermon.fulfilled, (state, action) => {
            state.loading = false;
            state.latestSermon = action.payload;
        });
        builder.addCase(fetchLatestSermon.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});

export default latestSermonSlice.reducer;